import { render, staticRenderFns } from "./IGo.vue?vue&type=template&id=3e92cac2&scoped=true&"
import script from "./IGo.vue?vue&type=script&lang=js&"
export * from "./IGo.vue?vue&type=script&lang=js&"
import style0 from "./IGo.vue?vue&type=style&index=0&id=3e92cac2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e92cac2",
  null
  
)

export default component.exports